import $ from 'jquery';
import { utils } from '../common/utils';

export function initDonationCommon(): void {
    $('.donation').on('stepchanged', (evt: JQuery.TriggeredEvent) => {
        const detail = (evt.originalEvent as CustomEvent).detail as { step: number };
        const step = detail.step;
        const url = document.location.href.replace(/\/+$/g, '') + '/steg-' + step;
        const title = document.title + ' steg ' + step;

        utils.pushDataLayer({
            event: 'VirtualPageview',
            virtualPageURL: url,
            virtualPageTitle: title
        });
    });

    utils.checkDataLayerPurchase();
}
